/* ==========================================================================
   Eco-Eze Compot theme — core interactions
   Drawers, modals, accordions, announcement bar, header behaviour.
   Cart-specific AJAX logic lives in cart-drawer.js
   ========================================================================== */
(function () {
  'use strict';

  document.documentElement.classList.remove('no-js');

  var DRAWER_IDS = {
    'cart-drawer': 'CartDrawer',
    'mobile-menu': 'mobile-menu'
  };

  function getDrawerEl(key) {
    var id = DRAWER_IDS[key] || key;
    return document.getElementById(id);
  }

  function openDrawer(key) {
    var el = getDrawerEl(key);
    if (!el) return;
    el.hidden = false;
    // allow the browser to paint hidden=false before animating in
    requestAnimationFrame(function () {
      el.classList.add('is-open');
    });
    document.body.classList.add('drawer-open');
    var closeBtn = el.querySelector('[data-drawer-close], .cart-drawer__close, .mobile-menu__close');
    if (closeBtn) closeBtn.focus({ preventScroll: true });
  }

  function closeDrawer(key) {
    var el = getDrawerEl(key);
    if (!el) return;
    el.classList.remove('is-open');
    document.body.classList.remove('drawer-open');
    window.setTimeout(function () {
      if (!el.classList.contains('is-open')) el.hidden = true;
    }, 320);
  }

  document.addEventListener('click', function (e) {
    var openTrigger = e.target.closest('[data-drawer-open]');
    if (openTrigger) {
      e.preventDefault();
      openDrawer(openTrigger.getAttribute('data-drawer-open'));
      return;
    }
    var closeTrigger = e.target.closest('[data-drawer-close]');
    if (closeTrigger) {
      e.preventDefault();
      closeDrawer(closeTrigger.getAttribute('data-drawer-close'));
      return;
    }
  });

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') {
      Object.keys(DRAWER_IDS).forEach(function (key) {
        var el = getDrawerEl(key);
        if (el && el.classList.contains('is-open')) closeDrawer(key);
      });
      closeModal('search-modal');
    }
  });

  window.CartDrawerActions = { open: function () { openDrawer('cart-drawer'); }, close: function () { closeDrawer('cart-drawer'); } };

  /* ---------------- Modals (search) ---------------- */
  function openModal(id) {
    var el = document.getElementById(id);
    if (!el) return;
    el.hidden = false;
    requestAnimationFrame(function () { el.classList.add('is-open'); });
    var input = el.querySelector('input[type="search"]');
    if (input) window.setTimeout(function () { input.focus(); }, 60);
  }
  function closeModal(id) {
    var el = document.getElementById(id);
    if (!el) return;
    el.classList.remove('is-open');
    window.setTimeout(function () { el.hidden = true; }, 220);
  }

  document.addEventListener('click', function (e) {
    var openTrigger = e.target.closest('[data-modal-open]');
    if (openTrigger) {
      e.preventDefault();
      openModal(openTrigger.getAttribute('data-modal-open'));
    }
    var closeTrigger = e.target.closest('[data-modal-close]');
    if (closeTrigger) {
      e.preventDefault();
      closeModal(closeTrigger.getAttribute('data-modal-close'));
    }
  });

  /* ---------------- Predictive search ---------------- */
  var searchInput = document.querySelector('[data-predictive-search-input]');
  var searchResults = document.querySelector('[data-predictive-search-results]');
  var searchTimer;

  if (searchInput && searchResults) {
    searchInput.addEventListener('input', function () {
      var query = searchInput.value.trim();
      window.clearTimeout(searchTimer);
      if (query.length < 2) {
        searchResults.innerHTML = '';
        return;
      }
      searchTimer = window.setTimeout(function () {
        fetch('/search/suggest?q=' + encodeURIComponent(query) + '&resources[type]=product,article,page&section_id=predictive-search')
          .then(function (res) { return res.text(); })
          .then(function (html) {
            searchResults.innerHTML = html;
          })
          .catch(function () {});
      }, 280);
    });
  }

  /* ---------------- Mobile submenu accordions ---------------- */
  document.addEventListener('click', function (e) {
    var toggle = e.target.closest('[data-accordion-toggle]');
    if (!toggle) return;
    var submenu = toggle.nextElementSibling;
    if (!submenu) return;
    var isOpen = !submenu.hidden;
    submenu.hidden = isOpen;
    toggle.setAttribute('aria-expanded', String(!isOpen));
  });

  /* ---------------- Generic content accordions (How it works / FAQ) ---------------- */
  document.addEventListener('click', function (e) {
    var trigger = e.target.closest('[data-accordion-item-toggle]');
    if (!trigger) return;
    var item = trigger.closest('[data-accordion-item]');
    var group = trigger.closest('[data-accordion-group]');
    var panel = item.querySelector('[data-accordion-panel]');
    var isOpen = item.classList.contains('is-open');

    if (group && group.getAttribute('data-accordion-single') === 'true') {
      group.querySelectorAll('[data-accordion-item].is-open').forEach(function (openItem) {
        if (openItem !== item) {
          openItem.classList.remove('is-open');
          var openPanel = openItem.querySelector('[data-accordion-panel]');
          if (openPanel) openPanel.style.maxHeight = null;
          openItem.querySelector('[data-accordion-item-toggle]').setAttribute('aria-expanded', 'false');
        }
      });
    }

    item.classList.toggle('is-open', !isOpen);
    trigger.setAttribute('aria-expanded', String(!isOpen));
    if (panel) panel.style.maxHeight = !isOpen ? panel.scrollHeight + 'px' : null;
  });

  /* ---------------- Collection mobile filters ---------------- */
  document.addEventListener('change', function (e) {
    var checkbox = e.target.closest('[data-filter-form] input[type="checkbox"][data-filter-input]');
    if (checkbox) {
      checkbox.closest('form').submit();
    }
  });

  document.addEventListener('click', function (e) {
    if (e.target.closest('[data-mobile-filter-toggle]')) {
      var filters = document.querySelector('[data-collection-filters]');
      if (filters) filters.classList.add('is-open');
    }
    if (e.target.closest('[data-mobile-filter-close]')) {
      var openFilters = document.querySelector('[data-collection-filters].is-open');
      if (openFilters) openFilters.classList.remove('is-open');
    }
  });

  /* ---------------- Carousels (featured collection, blog posts, etc.) ---------------- */
  document.addEventListener('click', function (e) {
    var prevBtn = e.target.closest('[data-carousel-prev]');
    var nextBtn = e.target.closest('[data-carousel-next]');
    if (!prevBtn && !nextBtn) return;
    var carousel = (prevBtn || nextBtn).closest('[data-carousel]');
    var track = carousel && carousel.querySelector('[data-carousel-track]');
    if (!track) return;
    var slide = track.querySelector(':scope > *');
    var amount = slide ? slide.getBoundingClientRect().width + 20 : 280;
    track.scrollBy({ left: prevBtn ? -amount : amount, behavior: 'smooth' });
  });

  /* ---------------- Announcement bar rotation ---------------- */
  var announcementBar = document.querySelector('[data-announcement-bar]');
  if (announcementBar) {
    var slides = announcementBar.querySelectorAll('.announcement-bar__slide');
    var speed = parseInt(announcementBar.getAttribute('data-autoplay'), 10) || 0;
    if (slides.length > 1 && speed > 0) {
      var current = 0;
      window.setInterval(function () {
        slides[current].classList.remove('is-active');
        current = (current + 1) % slides.length;
        slides[current].classList.add('is-active');
      }, speed * 1000);
    }
  }
document.querySelectorAll('[data-promo-popup]').forEach(function (popup) {
  var storageKey = popup.getAttribute('data-storage-key');
  var frequencyHours = parseFloat(popup.getAttribute('data-frequency-hours')) || 24;
  var dismissedAt = window.localStorage.getItem(storageKey);

  if (dismissedAt) {
    var hoursSince = (Date.now() - parseInt(dismissedAt, 10)) / 36e5;
    if (hoursSince < frequencyHours) return;
  }

  function showPopup() {
    if (document.body.classList.contains('drawer-open')) return;
    popup.hidden = false;
    requestAnimationFrame(function () { popup.classList.add('is-open'); });
  }

  function dismissPopup() {
    popup.classList.remove('is-open');
    window.localStorage.setItem(storageKey, String(Date.now()));
    window.setTimeout(function () { popup.hidden = true; }, 250);
  }

  popup.querySelectorAll('[data-promo-popup-close]').forEach(function (btn) {
    btn.addEventListener('click', dismissPopup);
  });

  var trigger = popup.getAttribute('data-trigger');
  if (trigger === 'exit') {
    document.addEventListener('mouseout', function (e) {
      if (!e.relatedTarget && e.clientY < 10) showPopup();
    });
  } else {
    var delay = parseFloat(popup.getAttribute('data-delay')) || 8;
    window.setTimeout(showPopup, delay * 1000);
  }
});

document.addEventListener('click', function (e) {
  var copyBtn = e.target.closest('[data-copy-code]');
  if (!copyBtn) return;
  var code = copyBtn.getAttribute('data-copy-code');
  if (navigator.clipboard) {
    navigator.clipboard.writeText(code).then(function () {
      var em = copyBtn.querySelector('em');
      if (em) {
        var original = em.textContent;
        em.textContent = 'Copied!';
        window.setTimeout(function () { em.textContent = original; }, 1800);
      }
    });
  }
});
  /* ---------------- Sticky header shadow ---------------- */
  var header = document.getElementById('SiteHeader');
  if (header && header.classList.contains('site-header--sticky')) {
    var lastScroll = 0;
    window.addEventListener('scroll', function () {
      var y = window.scrollY;
      header.classList.toggle('is-scrolled', y > 8);
      lastScroll = y;
    }, { passive: true });
  }

  /* ---------------- Promo popup ---------------- */
  document.querySelectorAll('[data-promo-popup]').forEach(function (popup) {
    var storageKey = popup.getAttribute('data-storage-key');
    var frequencyHours = parseFloat(popup.getAttribute('data-frequency-hours')) || 24;
    var dismissedAt = window.localStorage.getItem(storageKey);

    if (dismissedAt) {
      var hoursSince = (Date.now() - parseInt(dismissedAt, 10)) / 36e5;
      if (hoursSince < frequencyHours) return;
    }

    function showPopup() {
      if (document.body.classList.contains('drawer-open')) return;
      popup.hidden = false;
      requestAnimationFrame(function () { popup.classList.add('is-open'); });
    }

    function dismissPopup() {
      popup.classList.remove('is-open');
      window.localStorage.setItem(storageKey, String(Date.now()));
      window.setTimeout(function () { popup.hidden = true; }, 250);
    }

    popup.querySelectorAll('[data-promo-popup-close]').forEach(function (btn) {
      btn.addEventListener('click', dismissPopup);
    });

    var trigger = popup.getAttribute('data-trigger');
    if (trigger === 'exit') {
      document.addEventListener('mouseout', function (e) {
        if (!e.relatedTarget && e.clientY < 10) showPopup();
      });
    } else {
      var delay = parseFloat(popup.getAttribute('data-delay')) || 8;
      window.setTimeout(showPopup, delay * 1000);
    }
  });

  document.addEventListener('click', function (e) {
    var copyBtn = e.target.closest('[data-copy-code]');
    if (!copyBtn) return;
    var code = copyBtn.getAttribute('data-copy-code');
    if (navigator.clipboard) {
      navigator.clipboard.writeText(code).then(function () {
        var em = copyBtn.querySelector('em');
        if (em) {
          var original = em.textContent;
          em.textContent = 'Copied!';
          window.setTimeout(function () { em.textContent = original; }, 1800);
        }
      });
    }
  });

  /* ---------------- Newsletter / form success banners via query param ---------------- */
  if (window.location.search.indexOf('customer_posted=true') > -1) {
    document.querySelectorAll('[data-form-success-banner]').forEach(function (el) {
      el.hidden = false;
    });
  }
})();
